export default __webpack_public_path__ + "static/media/run-buddy-img.bff1ec64.PNG";